angular.module('dpw.directives')
    .directive('dpwHeader', [function () {
        return {
            restrict: 'A',
            replace: true,
            scope: true,
            templateUrl: 'dpw-header.html',
            controller: [
                '$scope', '$timeout', '$window', 'mixpanelService', 'user', 'organizationService', 'helpers',
                function ($scope, $timeout, $window, mixpanelService, user, organizationService, helpers) {
                    var self = this;
                    self.displayPrimaryNav = !helpers.isLoginPage();
                }
            ],
            controllerAs: 'headerCtrl',
            link: function () {
                //DPW-2742
                RCDPW.isLogin && window.setTimeout(function () {
                    $('.icon-icon_login_head').css('font-size', 21);
                    $('.announcement-hint-icon').css('font-size', 25);
                }, 1000);
            }
        };
    }]);
